import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { TextareaModule } from 'primeng/textarea';

@Component({
  selector: 'app-custom-textarea',
  templateUrl: './custom-textarea.component.html',
  styleUrls: ['./custom-textarea.component.scss'],
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomTextareaComponent),
      multi: true
    }
  ],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, TableModule, TextareaModule]
})
export class CustomTextareaComponent implements ControlValueAccessor {

  onChange: (value: string) => void = () => { };
  onTouched: () => void = () => { };

  @Input() autoResize: boolean = true;
  @Input() disabled: boolean = false;
  @Input() labelText: string = "";
  @Input() recovery: boolean = false;
  @Input() required: boolean = false;
  @Input() rows: number = 2;
  @Input() value: string = "";
  @Input() maxLength: number | null = null;
  @Output() onChangeText = new EventEmitter<string>();

  get characterCount(): number {
    return this.value?.length || 0;
  }

  get isMaxLengthExceeded(): boolean {
    return this.maxLength !== null && this.characterCount > this.maxLength;
  }

  changeText(event: string) {
    this.value = event;
    this.onChange(this.value);
    this.onTouched();
    this.onChangeText.emit(this.value);
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  selectAllText(event: Event) {
    const input = event.target as HTMLInputElement;
    input.select();
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: string): void {
    this.value = value;
  }

}
